import { CausedByException } from '@core/types'

export class StripeGenericException extends CausedByException {
	message = 'An error occurred while interacting with Stripe'
}
